"use client";

import { EPackageStatus } from "@/utilities/types/Package";
import cn from "@/utils/class-names";
import { Select } from "rizzui";

interface StatusPackageProps {
  status?: EPackageStatus;
  className?: string;
  onChange?: (value: EPackageStatus) => Promise<void>;
}

const statusOptions = [
  {
    value: EPackageStatus.ACTIVE,
    label: "Active",
  },
  {
    value: EPackageStatus.INACTIVE,
    label: "Deactive",
  },
];

export default function StatusPackage({
  status,
  className,
  onChange,
}: StatusPackageProps) {
  return (
    <Select
      size="sm"
      options={statusOptions}
      value={status ? status : ""}
      variant="outline"
      defaultValue={status ? status : ""}
      onChange={onChange}
      getOptionValue={(option) => option.value}
      displayValue={(selected) =>
        statusOptions.find((option) => option.value === selected)?.label ?? ""
      }
      className={cn("capitalize w-full h-[38px]", className)}
    />
  );
}
